import { ActionReducerMap, createSelector, MemoizedSelector } from '@ngrx/store';

import * as fromTopsFlops from './tops-flops';

export interface State {
	topsFlops: fromTopsFlops.State,
}

export const reducers: ActionReducerMap<State> = {
	topsFlops: fromTopsFlops.reducer,
};

export const FEATURE_STATE_NAME = 'xena:tops-flops';

export const getTopsFlopsState = state => state[FEATURE_STATE_NAME];
export const getTopsFlops: MemoizedSelector<object, fromTopsFlops.State> = createSelector(getTopsFlopsState, (state => state.topsFlops));



// WEBPACK FOOTER //
// ./src/app/xena/core/shared/components/tops-flops/state-management/reducers/index.ts